import { render, staticRenderFns } from "./UserNew.vue?vue&type=template&id=18f977fa&scoped=true&"
import script from "./UserNew.vue?vue&type=script&lang=ts&"
export * from "./UserNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f977fa",
  null
  
)

export default component.exports